import { INursingStationPickup } from 'src/app/models/pickup/pickup-utilities.model';
import {
  IIntakeReason,
  IPickupSetting,
} from '../../models/service/pickup-settings.model';

export class AddNursingStations {
  static readonly type = '[NursingStation] AddNursingStations]';
  constructor(public readonly payload: INursingStationPickup[]) {}
}
export class AddNSSettings {
  static readonly type = '[PickupTrays] AddNSSettings]';
  constructor(public readonly payload: IPickupSetting) {}
}

export class DeletePickUpTray {
  static readonly type = '[PickupTrays] DeletePickUpTray]';
  constructor(
    public readonly payload: { trayId: number; nursingStationId: number },
  ) {}
}

export class SaveIntakeReasons {
  static readonly type = '[PickupTrays] SaveIntakeReasons]';
  constructor(public readonly payload: { intakeReasons: IIntakeReason[] }) {}
}
